import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';

import Icon from '../../../Icon';
import SimpleAvatar from '../../../common/SimpleAvatar';

import styles from './styles.styl';

function ProgramListItem({ entity, formatMessage, onClick }) {
  const { name, logo = {}, organizationName } = { ...entity.program };

  const subTitle = useMemo(
    () =>
      [
        formatMessage({ id: 'healthboard.program.card.type' }),
        organizationName,
      ].join(', '),
    [organizationName],
  );

  return (
    <div className={styles.root} onClick={onClick}>
      <div className={styles.left}>
        {logo.thumbMin ? (
          <SimpleAvatar src={logo.thumbMin} text={name} size={32} />
        ) : (
          <Icon name="program" size={32} />
        )}
      </div>
      <div className={styles.right}>
        <p className={styles.meta}>{subTitle}</p>
        <p className={styles.strong}>
          {formatMessage({ id: 'program.invite.title' }, { name })}
        </p>
      </div>
    </div>
  );
}

ProgramListItem.propTypes = {
  onClick: PropTypes.func,
  entity: PropTypes.object,
  className: PropTypes.string,
  formatMessage: PropTypes.func,
};

export default ProgramListItem;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/ProgramListItem/index.jsx